import { PERIOD_GROUPING_FIELD_NAME } from "../../constants";
import { IReportActionParamsBase } from "../../models";
import { VisibilityState } from "../react-table.features";
import { getIsFlexPeriodGroupingApplied } from "./reports.grid.helpers";

export const getReportVisibilityState = ({
  reportApiDto,
  fetchCriteria,
}: IReportActionParamsBase): VisibilityState => {
  const {
    layout: { columns },
    report: { visibleColumns: visibleColumnsReport },
    reportTemplate: { periodGroupingColumn: periodGroupingColumnTemplate },
  } = reportApiDto;

  const visibilityState: VisibilityState = {};
  const groupingColumns = fetchCriteria?.flexGrouping?.groupingParams;

  const isFlexPeriodTemplateApplied = getIsFlexPeriodGroupingApplied(
    periodGroupingColumnTemplate,
    fetchCriteria,
  );

  if (visibleColumnsReport?.length) {
    // Base: restore saved column visibility
    for (const columnKey of visibleColumnsReport) {
      visibilityState[columnKey] = true;
    }

    // Inject any flex grouping columns not present in the saved state
    for (const col of groupingColumns ?? []) {
      visibilityState[col] = true;
    }

    // Inject the period grouping column when it is active
    if (isFlexPeriodTemplateApplied) {
      visibilityState[PERIOD_GROUPING_FIELD_NAME] = true;
    }

    // Explicitly hide every remaining catalog column (RYDE-7777). A saved selection is a subset,
    // so the rest must be marked `false` — not left undefined. The Manage Columns drawer lists a
    // column under "NOT SHOWING" only when its visibility is exactly `false`
    // (getInactiveItemsReports); an undefined column is neither active (it is absent from the saved
    // order) nor inactive, so it would disappear from the drawer and could never be re-enabled.
    // Internal helper columns (isHiddenFromView) are skipped: they must never surface as
    // toggleable rows in the drawer, so they stay undefined (excluded from NOT SHOWING) as before.
    for (const column of columns) {
      if (
        column.isHiddenFromView ||
        visibilityState[column.columnTemplateKey] !== undefined
      ) {
        continue;
      }

      visibilityState[column.columnTemplateKey] = false;
    }

    return visibilityState;
  }

  // No saved state: show all layout columns
  for (const { columnTemplateKey } of columns) {
    visibilityState[columnTemplateKey] = true;
  }

  return visibilityState;
};
